// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.skeleton {
	background-color: #e2e5e7;
	background-image:	linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5),rgba(255, 255, 255, 0));
	background-size: 40px 100%;
	background-repeat: no-repeat;
	background-position: left -40px top 0;
	animation: shine 1s ease infinite;
}

.skeleton--menu-title {
  height: 15px;
  width: 100px;
  border-radius: 4px;
}

.skeleton--menu-item {
  height: 24px;
  width: 170px;
  border-radius: 4px;
}

@keyframes shine {
	to {
		background-position: right -40px top 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/loader/css/skeleton.css"],"names":[],"mappings":";AACA;CACC,yBAAyB;CACzB,iHAAiH;CACjH,0BAA0B;CAC1B,4BAA4B;CAC5B,qCAAqC;CACrC,iCAAiC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;CACC;EACC,sCAAsC;CACvC;AACD","sourcesContent":["\n.skeleton {\n\tbackground-color: #e2e5e7;\n\tbackground-image:\tlinear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5),rgba(255, 255, 255, 0));\n\tbackground-size: 40px 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-position: left -40px top 0;\n\tanimation: shine 1s ease infinite;\n}\n\n.skeleton--menu-title {\n  height: 15px;\n  width: 100px;\n  border-radius: 4px;\n}\n\n.skeleton--menu-item {\n  height: 24px;\n  width: 170px;\n  border-radius: 4px;\n}\n\n@keyframes shine {\n\tto {\n\t\tbackground-position: right -40px top 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
